import React from 'react';
import {Helmet} from "react-helmet";
import { Link } from "gatsby"
import logo from '../img/logo-word-mark.svg'
import '../styles/nav.css'
import Session321 from './Session321';

const Header = (props) => {
    
    return ( 
    <div id="header">
        <Helmet><meta name="facebook-domain-verification" content="ko98e5hu5grsna5ge6dzc37n29u2w7" /></Helmet>
        <Link to="/"><div id="logo"><img src={logo} alt="menu icon" height="70px" width="240px"/></div></Link>
        <Session321 />
    </div> );
}
 
export default Header;